<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
  import EmptyLayout from './layouts/Empty'
  import MainLayout from './layouts/Main'
  import { event } from '@/plugins/event'
  import { mapActions } from 'vuex'

  export default {
    name: 'App',

    components: {
      EmptyLayout,
      MainLayout
    },

    computed: {
      layout() {
        return (this.$route.meta.layout || 'empty') + '-layout'
      }
    },

    created() {
      event.$on('app:init', () => {
        this.init()
      })
    },

    mounted() {
      this.init()
    },

    methods: {
      init() {
        if (this.$store.getters.isAuthenticated) {
          this.fetchRoutes()
          this.setAccInfo()
          this.fetchUsers()
          this.fetchNotifications()
          this.fetchDatabases()
        }
      },
      ...mapActions([ 'fetchRoutes', 'setAccInfo', 'fetchUsers', 'fetchNotifications', 'fetchDatabases' ])
    }
  }
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Roboto:400,500,700&display=swap&subset=cyrillic');
@import './assets/styles/style.scss';

// TRANSITIONS
.fade-enter {
  opacity: 0;
}
.fade-enter-active,
.fade-enter-leave {
  transition: opacity 0.5s ease-out;
}
.fade-leave-to {
  opacity: 0;
}
</style>
